import { createFileRoute } from '@tanstack/react-router'

// Leaf route — `noPlan` variant without a pinId.
// PlanViewerNew is mounted by the parent $viewType/route.tsx layout.
export const Route = createFileRoute(
  '/_authenticated/project/$projectId/pins/$viewType/noPlan/'
)({
  component: () => null
})
